<template>
  <div
    class="contact"
    :class="{
      'contact--selected': contact.isActive,
      'contact--disabled': disableSelection,
    }"
    @click="
      !disableSelection &&
        $emit('contact:selection', contactData.profileId || contact.profileId)
    "
  >
    <div class="contact__radio ml-3">
      <v-icon color="accent pa-4">
        {{ contact.isActive ? 'bhi-check-circle-filled' : 'bhi-ellipse' }}
      </v-icon>
    </div>
    <div class="contact__avatar ml-3">
      <profile-preview-image
        :avatarSize="48"
        :profileId="contactData.profileId || contact.profileId"
        :uuid="contactData.uuid || contact.uuid"
        :avatarClasses="['avatar', 'rounded']"
      />
    </div>
    <div class="contact__details ml-4">
      <h4 class="contact__name mb-1" v-if="contactDataName">
        {{ contactDataName }}
      </h4>
      <h4 class="contact__name mb-1" v-else>
        Chat
      </h4>
      <p class="contact__userType ma-0">{{ contact.userType }}</p>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import ProfilePreviewImage from '@/components/profile/ProfilePreviewImage.vue'
import { getDisplayName } from '@/helpers/getDisplayName'
export default {
  name: 'NewChatContact',
  components: {
    ProfilePreviewImage,
  },
  props: {
    contact: {
      type: Object,
      default: () => ({}),
    },
    disableSelection: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      contactData: this.$props.contact,
    }
  },
  computed: {
    ...mapState('profilePreviewsStates', ['profilePreviews']),
    contactDataName() {
      const { fullName, nick, firstName, lastName } = this.contactData

      return getDisplayName(
        fullName,
        firstName || this.contact.firstName,
        lastName || this.contact.lastName,
        nick,
      )
    },
  },
  created() {
    this.setContactData(this.profilePreviews)
  },
  methods: {
    setContactData(profiles) {
      const profilePreview =
        profiles.find(
          el =>
            (this.contact.uuid && el.uuid === this.contact.uuid) ||
            (this.contact.profileId && el.profileId === this.contact.profileId),
        ) || {}
      this.contactData = {
        ...this.contact,
        ...profilePreview,
      }
    },
  },
  watch: {
    profilePreviews(newProfiles) {
      this.setContactData(newProfiles)
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/styles/variables.scss';
@import '@/styles/mixins.scss';
$border-width: 2px;

.contact {
  display: flex;
  align-items: center;
  height: 72px;
  border: $border-width solid transparent;
  box-sizing: border-box;
  background-color: $bh-white;
  margin-bottom: 0.5 * $gutter;
  border-radius: 0.5 * $gutter;
  cursor: pointer;

  &.contact--selected {
    border: $border-width solid $bh-blue;
  }

  &.contact--disabled {
    cursor: auto;
    opacity: 0.7;

    .contact__name {
      color: $bh-gray--1;
    }
  }

  &__details {
    margin-left: $gutter;
  }

  &__userType {
    color: $bh-black;
    line-height: 1rem;
  }

  @include imageAvatar($class-name: 'contact');
}
</style>
